"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var mobx_1 = require("mobx");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var ActionLabel_1 = __importDefault(require("./styledComponents/ActionLabel"));

var Button_1 = __importDefault(require("./components/Button"));

var Icon_1 = __importDefault(require("./styledComponents/Icon"));

var Dropdown_1 = __importDefault(require("./styledComponents/Dropdown"));

var ClickLayer_1 = __importDefault(require("./styledComponents/ClickLayer"));

var DropdownItem_1 = __importDefault(require("./components/DropdownItem"));

var Translate_1 = __importDefault(require("../Translate/Translate"));

var ContextMenuPill_1 = __importDefault(require("./styledComponents/ContextMenuPill"));

var ContextMenu_meta_1 = require("./ContextMenu.meta");

var NAVIGATION_KEYS = [shared_1.KEYS.UP_ARROW, shared_1.KEYS.DOWN_ARROW, shared_1.KEYS.PAGE_UP, shared_1.KEYS.PAGE_DOWN, shared_1.KEYS.HOME, shared_1.KEYS.END];
var ACCEPT_KEYS = [shared_1.KEYS.ENTER, shared_1.KEYS.SPACE, shared_1.KEYS.SPACEBAR];
var EXIT_KEYS = [shared_1.KEYS.ESCAPE];

var ContextMenu =
/** @class */
function (_super) {
  __extends(ContextMenu, _super);

  function ContextMenu(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = ContextMenu_meta_1.CONTEXT_MENU_CATEGORY_KEY;
    _this.componentKey = ContextMenu_meta_1.CONTEXT_MENU_COMPONENT_KEY;
    _this.internalFocusedIndex = 0;
    _this.forceInternalFocus = false;
    _this.open = false;
    _this.focusedButton = false;

    _this.toggleDropdown = function () {
      _this.open = !_this.open;

      if (_this.open) {
        _this.forceInternalFocus = true;
      }
    };

    _this.handleSelection = function (e, itemIndex, action) {
      e.stopPropagation();
      var isMultiSelect = _this.props.isMultiSelect;

      if (itemIndex !== undefined && _this.internalFocusedIndex !== itemIndex) {
        _this.internalFocusedIndex = itemIndex;
        _this.forceInternalFocus = true;
      }

      action ? _this.handleActionSelection(action) : itemIndex !== undefined && _this.handleChildSelection(e, itemIndex);

      if (!isMultiSelect) {
        _this.open = false;
        _this.focusedButton = true;
      }
    };

    _this.handleKeyDown = function (e, itemIndex, action) {
      var isMultiSelect = _this.props.isMultiSelect;
      var key = e.key;
      var isNavEvent = NAVIGATION_KEYS.indexOf(key) !== -1;
      var isAcceptEvent = ACCEPT_KEYS.indexOf(key) !== -1;
      var isExitEvent = EXIT_KEYS.indexOf(key) !== -1;

      if (isNavEvent || isAcceptEvent || isExitEvent) {
        e.preventDefault();

        if (isNavEvent) {
          e.stopPropagation();
        }
      }

      if (_this.open) {
        if (key === shared_1.KEYS.TAB) {
          _this.toggleDropdown();
        } else if (isNavEvent) {
          _this.onOpenNavigation(key);
        } else if (isExitEvent) {
          _this.toggleDropdown();

          _this.focusedButton = true;
        } else if (isAcceptEvent && _this.itemReferences.length > 0 && _this.internalFocusedIndex >= 0) {
          _this.handleSelection(e, itemIndex, action);
        }
      } else {
        if (isNavEvent) {
          _this.onClosedNavigation(key);
        } else if (isAcceptEvent) {
          _this.toggleDropdown();
        }
      }
    };

    _this.shouldInternalFocusUpdate(props); // tslint:disable-next-line: no-this-assignment


    var _a = _this,
        hasActions = _a.hasActions,
        actions = _a.actions,
        hasChildren = _a.hasChildren,
        children = _a.children;
    var itemListLength = hasActions ? actions.length : hasChildren ? children.length : 0; // tslint:disable-next-line: prefer-array-literal

    _this.itemReferences = new Array(itemListLength);
    return _this;
  }

  Object.defineProperty(ContextMenu.prototype, "actions", {
    get: function get() {
      var _a = this.props,
          actions = _a.actions,
          payload = _a.payload;

      if (actions && actions.length > 0) {
        return actions.filter(function (action) {
          return !action.visible || action.visible(payload);
        });
      }

      return [];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ContextMenu.prototype, "hasActions", {
    get: function get() {
      // tslint:disable-next-line: no-this-assignment
      var actions = this.actions;
      return actions && actions.length > 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ContextMenu.prototype, "children", {
    get: function get() {
      var children = this.props.children;
      return Array.isArray(children) ? children : [children];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ContextMenu.prototype, "hasChildren", {
    get: function get() {
      // tslint:disable-next-line: no-this-assignment
      var children = this.children;
      return children && children.length > 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ContextMenu.prototype, "asset", {
    get: function get() {
      var asset = this.open ? 'base.contextMenu.dropdownIconExpanded' : 'base.contextMenu.dropdownIcon';
      return asset;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ContextMenu.prototype, "contextMenuLabel", {
    get: function get() {
      var _a = this.props,
          label = _a.label,
          labelIcon = _a.labelIcon,
          showPill = _a.showPill,
          pillProps = _a.pillProps;
      var overridingPillProps = Object.assign({}, pillProps, {
        value: label
      });

      if (this.hasIconLabel) {
        return react_1.default.createElement(Icon_1.default, __assign({}, labelIcon));
      }

      if (showPill) {
        return react_1.default.createElement(ContextMenuPill_1.default, __assign({}, overridingPillProps));
      }

      if (typeof label === 'string') {
        return react_1.default.createElement(Translate_1.default, null, label);
      }

      return label;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ContextMenu.prototype, "hasIconLabel", {
    get: function get() {
      var labelIcon = this.props.labelIcon;
      return !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(labelIcon);
    },
    enumerable: true,
    configurable: true
  });

  ContextMenu.prototype.componentDidUpdate = function () {
    this.shouldInternalFocusUpdate(this.props);
  };

  ContextMenu.prototype.shouldInternalFocusUpdate = function (props) {
    var focusedIndex = props.focusedIndex;

    if (focusedIndex !== undefined) {
      this.internalFocusedIndex = focusedIndex;
    }
  };

  ContextMenu.prototype.assignItemReference = function (reference, index) {
    if (reference && this.itemReferences && index >= 0 && index < this.itemReferences.length) {
      this.itemReferences[index] = reference;
    }
  };

  ContextMenu.prototype.focusItemIndex = function () {
    if (this.itemReferences && this.itemReferences[this.internalFocusedIndex] !== undefined) {
      this.itemReferences[this.internalFocusedIndex].focus();
    }
  };

  ContextMenu.prototype.handleActionSelection = function (action) {
    if (action) {
      var payload = this.props.payload;
      var onClick = action.onClick;

      if (onClick) {
        onClick(payload);
      }
    }
  };

  ContextMenu.prototype.handleChildSelection = function (e, itemIndex) {
    var onChildSelection = this.props.onChildSelection;

    if (onChildSelection) {
      onChildSelection(e, itemIndex);
    }
  };

  ContextMenu.prototype.onOpenNavigation = function (key) {
    var _a = this.props.pageKeyTraverseSize,
        pageKeyTraverseSize = _a === void 0 ? 3 : _a;
    var lastIndex = this.itemReferences.length - 1;
    var nextIndex = this.internalFocusedIndex;

    switch (key) {
      case shared_1.KEYS.UP_ARROW:
        nextIndex -= 1;
        break;

      case shared_1.KEYS.DOWN_ARROW:
        nextIndex += 1;
        break;

      case shared_1.KEYS.PAGE_UP:
        var pageUp = nextIndex - pageKeyTraverseSize;
        nextIndex = nextIndex > 0 && pageUp < 0 ? 0 : pageUp;
        break;

      case shared_1.KEYS.PAGE_DOWN:
        var pageDown = nextIndex + pageKeyTraverseSize;
        nextIndex = nextIndex < lastIndex && pageDown > lastIndex ? 0 : pageDown;
        break;

      case shared_1.KEYS.HOME:
        nextIndex = 0;
        break;

      case shared_1.KEYS.END:
        nextIndex = lastIndex;
        break;

      default:
        break;
    }

    if (nextIndex < 0) {
      nextIndex = lastIndex;
    }

    if (nextIndex > lastIndex) {
      nextIndex = 0;
    } // tslint:disable-next-line: object-shorthand-properties-first


    this.internalFocusedIndex = nextIndex;
    this.focusItemIndex();
  };

  ContextMenu.prototype.onClosedNavigation = function (key) {
    switch (key) {
      case shared_1.KEYS.UP_ARROW:
      case shared_1.KEYS.DOWN_ARROW:
        this.toggleDropdown();
        break;

      default:
        break;
    }
  };

  ContextMenu.prototype.appendIsFocus = function (props, itemIndex) {
    // tslint:disable-next-line: no-this-assignment
    var _a = this,
        forceInternalFocus = _a.forceInternalFocus,
        internalFocusedIndex = _a.internalFocusedIndex;

    var focusedIndexFromProps = this.props.focusedIndex;
    var isPropFocused = focusedIndexFromProps === itemIndex;
    var isInternallyFocused = focusedIndexFromProps === undefined && forceInternalFocus && internalFocusedIndex === itemIndex;

    if (isPropFocused || isInternallyFocused) {
      props.isFocused = true;
      this.forceInternalFocus = false;
    }

    return props;
  };

  ContextMenu.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        children = _a.children,
        actions = _a.actions,
        hideAsset = _a.hideAsset,
        payload = _a.payload,
        describedById = _a.describedById;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(Button_1.default, {
      className: this.hasIconLabel ? 'base-contextMenu-button-with-icon' : '',
      isFocused: this.focusedButton,
      onClick: function onClick(e) {
        e.stopPropagation();

        _this.toggleDropdown();
      },
      onKeyDown: function onKeyDown(e) {
        return _this.handleKeyDown(e);
      },
      "aria-describedby": describedById
    }, this.contextMenuLabel, !hideAsset && react_1.default.createElement(Icon_1.default, {
      asset: this.asset
    })), this.open && react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(ClickLayer_1.default, {
      onClick: this.toggleDropdown
    }), react_1.default.createElement(Dropdown_1.default, null, !this.hasActions && this.hasChildren && this.children.map(function (item, index) {
      var content = typeof item === 'string' ? react_1.default.createElement(Translate_1.default, null, item) : item;

      var dropdownProps = _this.appendIsFocus({}, index);

      return react_1.default.createElement(DropdownItem_1.default, __assign({
        id: "" + index,
        key: "" + index,
        onClick: function onClick(event) {
          _this.handleSelection(event, index);
        },
        onKeyDown: function onKeyDown(e) {
          return _this.handleKeyDown(e, index);
        },
        getItemReference: function getItemReference(reference) {
          return _this.assignItemReference(reference, index);
        }
      }, dropdownProps), content);
    }), this.hasActions && this.actions.map(function (action, index) {
      var key = action.key,
          label = action.label;

      var dropdownProps = _this.appendIsFocus({}, index);

      return react_1.default.createElement(DropdownItem_1.default, __assign({
        id: key || "" + index,
        key: key || "" + index,
        onClick: function onClick(event) {
          _this.handleSelection(event, index, action);
        },
        onKeyDown: function onKeyDown(e) {
          return _this.handleKeyDown(e, index, action);
        },
        getItemReference: function getItemReference(reference) {
          return _this.assignItemReference(reference, index);
        }
      }, dropdownProps), react_1.default.createElement(ActionLabel_1.default, null, react_1.default.createElement(Translate_1.default, null, label)));
    }))));
  };

  __decorate([mobx_1.observable], ContextMenu.prototype, "open", void 0);

  __decorate([mobx_1.observable], ContextMenu.prototype, "focusedButton", void 0);

  __decorate([mobx_1.computed], ContextMenu.prototype, "actions", null);

  __decorate([mobx_1.computed], ContextMenu.prototype, "hasActions", null);

  __decorate([mobx_1.computed], ContextMenu.prototype, "children", null);

  __decorate([mobx_1.computed], ContextMenu.prototype, "hasChildren", null);

  __decorate([mobx_1.computed], ContextMenu.prototype, "contextMenuLabel", null);

  __decorate([mobx_1.computed], ContextMenu.prototype, "hasIconLabel", null);

  __decorate([mobx_1.action], ContextMenu.prototype, "handleSelection", void 0);

  ContextMenu = __decorate([mobx_react_1.observer], ContextMenu);
  return ContextMenu;
}(shared_1.ComponentBase);

exports.ContextMenu = ContextMenu;
exports.default = shared_1.InjectedStyledComponent(ContextMenu, ContextMenu_meta_1.CONTEXT_MENU_CATEGORY_KEY, ContextMenu_meta_1.CONTEXT_MENU_COMPONENT_KEY);